/*
Документация по работе в шаблоне:
Документация слайдера: https://swiperjs.com/
Сниппет(HTML): swiper
*/

// Подключаем слайдер Swiper из node_modules
// При необходимости подключаем дополнительные модули слайдера, указывая их в {} через запятую
// Пример: { Navigation, Autoplay }
import Swiper, {
  Navigation,
  Pagination,
  Parallax,
  Autoplay,
  Thumbs,
  Lazy,
} from "swiper";
/*
Основниые модули слайдера:
Navigation, Pagination, Autoplay,
EffectFade, Lazy, Manipulation
Подробнее смотри https://swiperjs.com/
*/

// Стили Swiper
// Базовые стили
import "../../scss/libs/_swiper.scss";
// Полный набор стилей из scss/libs/swiper.scss
// import "../../scss/libs/swiper.scss";
//import "swiper/modules/lazy/lazy.scss";

// Инициализация слайдеров
function initSliders() {
  const showSlider = {
    on: {
      init() {
        const loader = this.el.parentNode.querySelector('.loader-st1');
        this.el.classList.remove('invisible');
        loader && loader.remove();
      },
    },
  }

  // Рекомендации
  new Swiper(".offers-swiper", {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 7000,
      disableOnInteraction: false,
    },
    // If we need pagination
    pagination: {
      el: ".offers-swiper-pagination",
      clickable: true,
    },
    // Navigation arrows
    navigation: {
      nextEl: ".offers-swiper-button-next",
      prevEl: ".offers-swiper-button-prev",
    },

    ...showSlider,
  });

  // Популярные товары
  new Swiper(".swiperWrapper .swiper", {
    modules: [Navigation],
    slidesPerView: "auto",
    loopedSlides: 4,
    spaceBetween: 29,
    loop: true,
    // Navigation arrows
    navigation: {
      prevEl: ".swiperWrapper .swiperBtnPrev",
      nextEl: ".swiperWrapper .swiperBtnNext",
    },
    breakpoints: {
      // when window width is >= 870px
      870: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
      // when window width is >= 1600px
      1600: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      },
    },

    ...showSlider,
  });

  // Сезонные товары отключены
  /*new Swiper(".season-swiper", {
    modules: [Navigation, Pagination],
    allowTouchMove: false,
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    // If we need pagination
    pagination: {
      el: ".season-swiper-pagination",
      clickable: true,
    },
    // Navigation arrows
    navigation: {
      prevEl: ".seasonSwiperBtnPrev",
      nextEl: ".seasonSwiperBtnNext",
    },
  });*/

  // Отзывы
  new Swiper(".reviews-swiper", {
    modules: [Navigation],
    slidesPerView: "auto",
    spaceBetween: 22,
    loop: true,
    // Navigation arrows
    navigation: {
      nextEl: ".reviews-swiper-button-next",
      prevEl: ".reviews-swiper-button-prev",
    },
    breakpoints: {
      // when window width is >= 992px
      992: {
        slidesPerView: 3,
        spaceBetween: 29,
      },
    },
  });

  // Партнеры
  new Swiper(".partner-swiper", {
    modules: [Autoplay, Pagination],
    slidesPerView: "auto",
    spaceBetween: 20,
    loop: true,
    loopedSlides: 4,
    allowTouchMove: false,
    autoplay: {
      delay: 3000,
      disableOnInteraction: true,
    },
    // If we need pagination
    pagination: {
      el: ".partner-swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      // when window width is >= 576px
      576: { spaceBetween: 30, },
      // when window width is >= 768px
      768: {
        spaceBetween: 40,
      },
      // when window width is >= 1200px
      1200: {
        spaceBetween: 90,
      },
    },
  });

  // Каталог Рекомендуемые товары
  new Swiper(".catalog-swiper", {
    modules: [Navigation, Pagination],
    slidesPerView: "auto",
    loopedSlides: 4,
    spaceBetween: 29,
    loop: true,
    // Navigation arrows
    navigation: {
      nextEl: ".catalog-swiper-button-next",
      prevEl: ".catalog-swiper-button-prev",
    },
    // If we need pagination
    pagination: {
      el: ".catalog-swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      // when window width is >= 1400px
      1400: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
    },
  });
}
// Наши проекты общий
function casesSliderInit() {
  new Swiper(".cases-swiper", {
    modules       : [Navigation, Pagination],
    allowTouchMove: false,
    slidesPerView : 1,
    spaceBetween  : 20,
    loop          : false,
    // If we need pagination
    pagination    : {
      el       : ".cases-swiper-pagination",
      clickable: true,
    },
    // Navigation arrows
    navigation    : {
      nextEl: ".cases-swiper-button-next",
      prevEl: ".cases-swiper-button-prev",
    },

    on: {
      init() {
        const loader = this.el.parentNode.parentNode.querySelector('.loader-st1'),
              el = this.el;

        // Наши проекты слайдер внутри
        document.querySelectorAll('.cases-swiper-slide').forEach(n => {
          const thumbs = n.querySelector('.swiperThumbs'),
                head   = n.querySelector('.swiperHead');

          const swiper = new Swiper(thumbs, {
            modules            : [Lazy],
            loop               : true,
            lazy               : true,
            spaceBetween       : 15,
            slidesPerView      : 3,
            freeMode           : true,
            watchSlidesProgress: true,
          });
          new Swiper(head, {
            modules     : [Thumbs, Lazy],
            lazy        : true,
            loop        : true,
            spaceBetween: 15,
            thumbs      : {
              swiper,
            },

            on: {
              init() {
                el.classList.remove('invisible');
                loader && loader.remove();
              },
            },
          });
        });
      },
    },
  });
}
function scrollEvent() {
  let node = document.getElementById('casesSection');

  if (node && window.scrollY + 1000 > node.offsetTop) {
    casesSliderInit();
    window.removeEventListener('scroll', scrollEvent);
  }
}

window.addEventListener("load", function (e) {
  // Запуск инициализации слайдеров
  initSliders();

  window.document.addEventListener('scroll', scrollEvent);

  setTimeout(() => {
    // Карточка товара (Навигация карточки)
    new Swiper(".card-images-subswiper", {
      modules: [Navigation],
      slidesPerView: 3,
      spaceBetween: 18,
      loop: false,
      freeMode: true,
      watchSlidesProgress: true,
      // Navigation arrows
      navigation: {
        nextEl: ".card-image-swiper-button-next",
        prevEl: ".card-image-swiper-button-prev",
      },
    });

    // Карточка товара (Галерея)
    new Swiper("#gallerySlider .swiperWrapper", {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: 14,
      loop: true,
      // Navigation arrows
      navigation: {
        nextEl: "#gallerySlider .swiper-button-next",
        prevEl: "#gallerySlider .swiper-button-prev",
      },
      // If we need pagination
      pagination: {
        el: "#gallerySlider .swiperPagination",
        clickable: true,
      },
      breakpoints: {
        // when window width is >= 576px
        576: {
          slidesPerView: 2,
        },
        // when window width is >= 768px
        768: {
          slidesPerView: 3,
        },
        // when window width is >= 992px
        992: {
          spaceBetween: 17,
        },
        // when window width is >= 1200px
        1200: {
          slidesPerView: 4,
          spaceBetween: 29,
        },
      },
    });

    // Карточка товара (Похожие товары)
    new Swiper(".sliderSimilar .swiperWrapper", {
      modules: [Navigation, Pagination],
      slidesPerView: "auto",
      //loopedSlides: 3,
      spaceBetween: 29,
      loop: true,
      // Navigation arrows
      navigation: {
        nextEl: ".sliderSimilar .swiper-button-next",
        prevEl: ".sliderSimilar .swiper-button-prev",
      },
      // If we need pagination
      pagination: {
        el: ".sliderSimilar .swiperPagination",
        clickable: true,
      },
      breakpoints: {
        // when window width is >= 992px
        992: {
          slidesPerView: 3,
        },
        // when window width is >= 1200px
        1200: {
          slidesPerView: 4,
        },
      },
    });

    // Карточка товара (Рекомендуемые товары)
    new Swiper(".sliderRecommended .swiperWrapper", {
      modules: [Navigation, Pagination],
      slidesPerView: "auto",
      //loopedSlides: 3,
      spaceBetween: 29,
      loop: true,
      // Navigation arrows
      navigation: {
        nextEl: ".sliderRecommended .swiper-button-next",
        prevEl: ".sliderRecommended .swiper-button-prev",
      },
      // If we need pagination
      pagination: {
        el: ".sliderRecommended .swiperPagination",
        clickable: true,
      },
      breakpoints: {
        // when window width is >= 992px
        992: {
          slidesPerView: 3,
        },
        // when window width is >= 1200px
        1200: {
          slidesPerView: 4,
        },
      },
    });
  }, 300);
});
